import React from 'react'
import { PropTypes as T } from 'prop-types'
import clsx from 'clsx'

import { StyledTypography } from './styled'

export const defaultTypeMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  caption1: 'h6',
  caption2: 'h6',
  caption3: 'h6',
  body1: 'span',
  body2: 'span',
  body3: 'span',
  input: 'span',
  button1: 'span',
  button2: 'span',
  button3: 'span',
}

const Typography = (props) => {
  const {
    children,
    className,
    color,
    component,
    fontFamily,
    fontSize,
    fontWeight,
    lineHeight,
    margin,
    padding,
    textAlign,
    textDecoration,
    textTransform,
    text,
    variant,
    ...otherProps
  } = props
  const Component = component || defaultTypeMapping[variant] || 'span'

  return (
    <StyledTypography
      as={component || Component}
      variant={variant}
      $textAlign={textAlign}
      $textDecoration={textDecoration}
      $textTransform={textTransform}
      color={color}
      margin={margin}
      padding={padding}
      className={clsx(className, variant, 'typography')}
      fontWeight={fontWeight}
      fontFamily={fontFamily}
      fontSize={fontSize}
      $lineHeight={lineHeight}
      {...otherProps}
    >
      {children || text}
    </StyledTypography>
  )
}

export default Typography

Typography.propTypes = {
  children: T.node,
  className: T.string,
  color: T.string,
  component: T.oneOfType([T.string, T.node, T.func]),
  fontFamily: T.string,
  fontSize: T.string,
  fontWeight: T.oneOfType([T.number, T.string]),
  lineHeight: T.string,
  margin: T.string,
  padding: T.oneOfType([T.number, T.string]),
  textAlign: T.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
  textDecoration: T.string,
  textTransform: T.string,
  text: T.oneOfType([T.node, T.string, T.number]),
  variant: T.oneOf([
    'h1',
    'h2',
    'h3',
    'h4',
    'caption1',
    'caption2',
    'caption3',
    'body1',
    'body2',
    'body3',
    'input',
    'button1',
    'button2',
    'button3',
  ]),
}

Typography.defaultProps = {
  variant: 'body1',
}
